import React from 'react';

import { IconPack, SecondaryNavContent } from '../../models/app-data-model';
import NavMenuContent from '../nav-menu-content/nav-menu-content';
import './nav-menu-column.scss';

export type NavMenuColumnProps = {
  navContent: SecondaryNavContent[];
  columnMaxWidth?: '1/2' | '1/3';
  iconPack?: IconPack[];
};

const NavMenuColumn: React.FC<NavMenuColumnProps> = ({ navContent, columnMaxWidth, iconPack }: NavMenuColumnProps) => {
  const childRenderings = navContent?.map((x, index) => <NavMenuContent content={x} key={index} iconPack={iconPack} />);
  const styleClass = columnMaxWidth === '1/2' ? 'max-width-50' : '';

  return <div className={`nav-menu-column ${styleClass}`}>{childRenderings}</div>;
};

export default NavMenuColumn;
